import { useMutation } from '@tanstack/react-query'
import { ApiResponse } from '@type/api'
import { axiosDirect } from '@utils/axios'

function delay(ms: number): Promise<void> {
  return new Promise<void>((resolve) => setTimeout(resolve, ms))
}

export interface AuthRecoveryApiResponse {
  email: string
}

export const authRecovery = async (email: string | null) => {
  const { data: response } = await axiosDirect.post<ApiResponse<AuthRecoveryApiResponse>>('/auth/recovery', {
    email: email,
  })
  await delay(1500)
  return response
}

export const useAuthRecoveryMutation = () => {
  return useMutation({
    mutationFn: (email: string) => authRecovery(email),
  })
}
